/**
 * The product's own name. BizForge is the app; the tenant (e.g. [DEMO] Summit
 * Home Services) is the business using it. Use PRODUCT_NAME for app chrome, page
 * titles and "update available" copy; use the workspace name (useWorkspace())
 * wherever the text means the business. Never hard-code a tenant's name in
 * app chrome. VITE_PRODUCT_NAME sets it at build time (the product is being
 * renamed; docs/engineering/adr/0001-tenant-hostnames.md).
 */
export const PRODUCT_NAME: string = (import.meta.env.VITE_PRODUCT_NAME as string | undefined)?.trim() || 'BizForge'
